








































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import SocketFacade from "@/app/core/api/app-server/SocketFacade";
import { StoreUseData } from "@/@types/store";
import { SceneAndLayer, SceneLayer } from "@/@types/room";
import GameObjectManager from "@/app/basic/GameObjectManager";
import VueEvent from "@/app/core/decorator/VueEvent";
import draggable from "vuedraggable";
import EditSceneLayerComponent from "@/app/basic/map/EditSceneLayerComponent.vue";

@Component({ components: { EditSceneLayerComponent, draggable } })
export default class EditSceneLayerChooserComponent extends Vue {
  @Prop({ type: String, required: true })
  private sceneId!: string;

  @Prop({ type: String, default: "" })
  private value!: string; // selectedLayerId
  private dragMode: boolean = false;
  private dragModeProcessed: boolean = false;
  private orderChangingIdList: string[] = [];
  private changeOrderId: string = "";

  public input(value: string) {
    this.$emit("input", value);
  }

  private get localValue(): string {
    return this.value;
  }

  private set localValue(value: string) {
    this.input(value);
  }

  @VueEvent
  private get sceneAndLayerInfo(): (id: string) => StoreUseData<SceneAndLayer> {
    return (id: string) =>
      this.sceneAndLayerList.filter(sal => sal.data!.layerId === id)[0];
  }

  private sceneAndLayerInfoList: StoreUseData<SceneAndLayer>[] | null = null;
  private layerInfoList: StoreUseData<SceneLayer>[] | null = null;
  private sceneAndLayerCC = SocketFacade.instance.sceneAndLayerCC();

  private sceneAndLayerList = GameObjectManager.instance.sceneAndLayerList;
  private layerList = GameObjectManager.instance.sceneLayerList;

  @VueEvent
  private async changeLayerUse(mapAndKayerId: string, checked: boolean) {
    const option: any = {};
    if (this.dragMode) {
      option.continuous = true;
    } else {
      await this.sceneAndLayerCC.touchModify([mapAndKayerId]);
    }
    let data = this.sceneAndLayerInfoList!.filter(
      ml => ml.id === mapAndKayerId
    )[0].data!;
    data.isUse = checked;
    await this.sceneAndLayerCC.update([mapAndKayerId], [data], [option]);
  }

  @LifeCycle
  private async mounted() {
    this.sceneAndLayerInfoList = this.sceneAndLayerList
      .filter(map => map.data!.sceneId === this.sceneId)
      .sort((m1, m2) => {
        if (m1.order < m2.order) return -1;
        if (m1.order > m2.order) return 1;
        return 0;
      });
    this.layerInfoList = this.sceneAndLayerInfoList
      .map(ml => this.layerList.filter(l => l.id === ml.data!.layerId)[0])
      .filter(l => l);
  }

  @LifeCycle
  private async beforeDestroy(): Promise<void> {
    await this.sceneAndLayerCC.releaseTouch(this.orderChangingIdList);
  }

  @Watch("sceneAndLayerList", { deep: true })
  private async onChangeSceneAndLayerInfoList() {
    if (this.dragMode) {
      const idList = this.sceneAndLayerList
        .filter(
          sao =>
            this.orderChangingIdList.filter(oId => oId === sao.id).length === -1
        )
        .map(sao => sao.id!);

      try {
        await this.sceneAndLayerCC.touchModify(idList);
        this.orderChangingIdList.push(...idList);
      } catch (err) {
        alert("このタイミングでは例外にならないはず");
      }
    }
  }

  @VueEvent
  private onMouseHover(isMouseOn: boolean) {
    this.$emit("hover", isMouseOn);
  }

  @Watch("dragMode")
  private async onChangeDragMode() {
    this.$emit("onChangeDragMode", this.dragMode);

    const idList: string[] = this.sceneAndLayerList.map(sao => sao.id!);
    if (this.dragMode) {
      try {
        await this.sceneAndLayerCC.touchModify(idList);
        this.orderChangingIdList = idList;
      } catch (err) {
        alert("Failure to get sceneAndLayerList's lock.\nPlease try again.");
        this.dragModeProcessed = true;
        this.dragMode = false;
        this.orderChangingIdList = [];
      }
    } else {
      this.orderChangingIdList = [];
      if (!this.dragModeProcessed) {
        try {
          await this.sceneAndLayerCC.releaseTouch(idList);
          this.dragModeProcessed = false;
        } catch (err) {
          // Nothing.
        }
      }
    }
  }

  @VueEvent
  private async onSortOrderChange() {
    window.console.log("onEndOrderChange");
    const idList: string[] = this.layerInfoList!.map(sao => sao.id!);
    const idOrderList = idList.map(id => {
      const sao = this.sceneAndLayerList.filter(
        sao => sao.data!.layerId === id
      )[0];
      return {
        id: sao.id!,
        order: sao.order,
        target: false
      };
    });
    const orderList = idOrderList.concat().map(ido => ido.order);
    orderList.sort((o1, o2) => {
      if (o1 < o2) return -1;
      if (o1 > o2) return 1;
      return 0;
    });
    idOrderList.forEach((ido, idx: number) => {
      if (ido.order !== orderList[idx]) ido.target = true;
      ido.order = orderList[idx];
    });

    const orderedIdList: string[] = [];
    const dataList: SceneAndLayer[] = [];
    const optionList: any[] = [];

    idList.forEach((layerId, idx) => {
      if (!idOrderList[idx].target) return;
      const id = idOrderList[idx].id;
      const data = this.sceneAndLayerList.filter(sao => sao.id === id)[0].data!;
      orderedIdList.push(id);
      dataList.push(data);
      optionList.push({
        order: idOrderList[idx].order,
        continuous: true
      });
    });
    await this.sceneAndLayerCC.update(orderedIdList, dataList, optionList);
  }
}
